<div id="sp-dropdown" class="dropdown-warp" [ngClass]="[forHeader ? 'for-header' : '', color]">
  <span (click)="openDropdown()" [ngClass]="openItem ? 'opened' : 'close'" *ngIf="!isContextMenu">
    <div class="custom-icon default">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="custom-icon white-icon">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <img class="icon-for-header" src="../../../public/resources/images/account.svg" alt="" />
  </span>
  <ul class="item" [ngClass]="[align && align === 'left' ? 'item-left' : '', openItem || isContextMenu ? 'opened' : 'close']">
    <li *ngFor="let link of links">
      <a *ngIf="link.url" [routerLink]="link.url" [queryParams]="link.queryParams ? link.queryParams : null"
        (click)="link.action ? link.action(dropDownId) : null; closeDropdown()">{{
        link.label }}</a>
      <a *ngIf="!link.url" (click)="link.action ? link.action(dropDownId) : null; closeDropdown()">{{ link.label }}</a>
      <a></a>
    </li>
  </ul>
</div>